import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectShippingCity, selectShippingCountry, selectShippingGeoCode, selectShippingPostalCode, selectShippingState } from '../slices/shipping';

const useShipping = () => {
    const city = useSelector(selectShippingCity);
    const country = useSelector(selectShippingCountry);
    const postalCode = useSelector(selectShippingPostalCode);
    const geoCode = useSelector(selectShippingGeoCode)?.geoCode ?? '';
    const state = useSelector(selectShippingState);
    return useMemo(
        () => ({ city, country, geoCode, postalCode, state }),
        [ city, country, geoCode, postalCode, state ]
    );
}

export default useShipping;
